import { IModifier } from './Modifier';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { EAnimationModifiers } from '../../Animation/SpineWrapperEventManager';
import { getAllEventModifiers } from '../../Utils/ModifierUtils';

export class OfAKindModifier implements IModifier {
    constructor(readonly gameStore: GameStore) {}

    public modifierCheck(name: string): boolean {
        return !!OfAKindModifier.getOfAKindModifier(getAllEventModifiers(name));
    }

    public requirementCheck(name: string): boolean {
        const highestSymbolCountOnPayLine = this.gameStore.get(EGameStoreKeys.HighestSymbolCountOnPayLine);
        const nameModifiers = getAllEventModifiers(name);
        const ofAKindModifier = OfAKindModifier.getOfAKindModifier(nameModifiers);
        const { active: isInDebugWinPresentationMode, ofAKindModifier: debugOfAKindModifier } = this.gameStore.get(
            EGameStoreKeys.DebugWinPresentationModeState
        );
        const canPlayOutsideOfDebug = ofAKindModifier === highestSymbolCountOnPayLine;
        const canPlayInDebug = ofAKindModifier === debugOfAKindModifier;
        const canPlay = isInDebugWinPresentationMode ? canPlayInDebug : canPlayOutsideOfDebug;
        return canPlay;
    }

    public static getOfAKindModifier(nameParams: string[]): number | undefined {
        const modifier = nameParams.find((param) => param.includes(EAnimationModifiers.OF_A_KIND));
        if (!modifier) return;
        const match = new RegExp(/\d+/).exec(modifier);
        if (!match) return;
        const num = Number.parseInt(match[0], 10);
        return num;
    }
}
